import { useContext, useMemo } from 'react';
import { translationsContext } from '../translationsContext';

/**
 * Represents the result of using translations with namespaces.
 *
 * @typeParam T Type of the translations object.
 */

/**
 * Custom hook for accessing all translations with namespaces provided to TranslationsProvider.
 *
 * @typeParam T Type of the translations object.
 * @returns Object which contains translations and related information.
 */

export const useTranslationsWithNamespaces = () => {
  const {
    translationsWithNamespaces,
    currentLanguage,
    language,
    defaultTranslationsWithNamespaces
  } = useContext(translationsContext);
  return useMemo(() => ({
    translationsWithNamespaces: translationsWithNamespaces ? translationsWithNamespaces : defaultTranslationsWithNamespaces,
    currentLanguage: currentLanguage ?? '',
    language: language ?? ''
  }), [language, currentLanguage, defaultTranslationsWithNamespaces, translationsWithNamespaces]);
};
//# sourceMappingURL=useTranslationsWithNamespaces.js.map